export const LOGIN_STATUS_START = 'LOGIN_STATUS_START';
export const LOGIN_STATUS_SUCCESS = 'LOGIN_STATUS_SUCCESS';
export const LOGIN_STATUS_ERROR = 'LOGIN_STATUS_ERROR';
export const CLEAR_LOGIN_STATUS_ERRORS = 'CLEAR_LOGIN_STATUS_ERRORS';
export const UPDATE_AUTH_DATA = 'UPDATE_AUTH_DATA';
